import {Component, ComponentFactoryResolver, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AlertComponent} from '../shared/dialogs/alert/alert.component';
import {MatDialog} from '@angular/material/dialog';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {PublishService} from '../services/publish.service';
import {PublishV2Service} from '../services/publish-v2.service';
import {MatTableDataSource} from '@angular/material/table';
import {EventGuestDialogComponent} from './dialogs/event-guest-dialog/event-guest-dialog.component';

@Component({
  selector: 'app-event-publish',
  templateUrl: './event-publish.component.html',
  styleUrls: [ './event-publish.component.scss' ]
})
export class EventPublishComponent implements OnInit {

  public criteria: string;
  public master: any;
  public event: any;
  public events: any[] = []
  public activities: any[] = []
  public _activities: any[] = []
  public allActivities: any[] = []
  public topics: any[] = []
  public agenda: any[] = []
  public deptos: any[] = [];
  public rooms: any[] = [];
  public days: any[] = [];
  public speakers: any[] = [];
  public countries: any[] = [];
  public staffMembers: any[] = [];

  public errors: any[] = [];

  public selectedDay: any;
  public selectedRoom: any;
  public selectedDepto: any;
  public selectedSpeaker: any;
  public notFound: boolean = false;

  public isSpeaker: boolean = false;

  public member_name: string;
  public member_state: string;
  public member_country: string;
  public member_flag: string;
  public member_text: string;
  public member_image: string;

  public currentImage: any;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'image', 'flag', 'name' ];

  public isCongress: any;

  constructor (
    private _route: ActivatedRoute,
    private _publishService: PublishService,
    private _publishV2Service: PublishV2Service,
    private _dialog: MatDialog,
    private _spinnerService: SpinnerService
  ) {
    const params = this._route.snapshot.paramMap.get('key');
    const splits = params.split(":")
    // console.log(splits[ 0 ])
    /// console.log(splits[ 1 ])
    const key = splits[ 0 ]
    this.isCongress = splits[ 1 ]

    this.clearFilters();

    // if (this.isCongress === "true") {
    this.loadDataCongress(key, this.isCongress)
    // } else {
    //   this.loadDataCongress(key, this.isCongress) //loadDataEvent
    // }

    this.loadCountries();
    this.loadStaffMembers()
  }

  ngOnInit () {
  }

  async loadCountries () {
    this.countries = await this._publishV2Service.getCountries();
  }

  async loadStaffMembers () {
    this.staffMembers = await this._publishV2Service.getStaffMembers();
  }

  async loadDataCongress (key: any, isCongress: any) {
    // console.log('key: ' + key);
    const waiting = this._spinnerService.show();
    try {
      const {master, events, locations, agenda, days, activities, topics, staffMembers, rooms, deptos, countries} = await this._publishV2Service.getPublishData(key, isCongress);

      this.master = master;

      this.currentImage = this.master.image_web;
      this.days = days;
      this.rooms = rooms;
      this.deptos = deptos;

      if (!master) {
        throw new Error('Master event not found for key: ' + key);
      }

      const speakersAgenda = await this._publishV2Service.getSpeakersData(
        master,
        agenda,
        activities,
        locations,
        staffMembers,
        countries
      );

      this.speakers = speakersAgenda
      this.dataSource = new MatTableDataSource(this.speakers);
      // console.log('this.speakers: ' + JSON.stringify(this.speakers));
      // console.log("--------------------------------------")

      this.allActivities = await this._publishV2Service.makeListOfActivities(
        master,
        {
          "events": isCongress ? events : master,
          "days": days,
          "activities": activities,
          "topics": topics,
          "rooms": rooms,
          "deptos": deptos,
          "agenda": agenda
        }
      )

      this._activities = this.allActivities;
      // console.log('allActivities: ' + JSON.stringify(this.allActivities));
      // console.log("--------------------------------------")

    } catch (err: any) {
      console.log('loadDataCongress: ' + err.message);
    } finally {
      waiting.close();
    }
  }


  selectDay (event: any) {
    if (event == "-Todos os dias") {
      this.selectedDay = "-Todos os dias";
    } else {
      this.selectedDay = event
    }
  }

  selectRoom (event: any) {
    if (event == "-Todas as salas") {
      this.selectedRoom = "-Todas as salas";
    } else {
      this.selectedRoom = event
    }
  }

  selectDepartent (event: any) {
    if (event == "-Todas as atividades") {
      this.selectedDepto = "-Todas as atividades";
    } else {
      this.selectedDepto = event
    }
  }

  selectSpeaker (event: any) {
    if (event == "-Todos os palestrantes") {
      this.selectedSpeaker = null;
    } else {
      this.selectedSpeaker = event;
    }
  }

  filter () {
    let ctrl = false;
    this._activities = [];

    this.allActivities.forEach(activity => {
      let setArray: any[] = [];
      setArray.push({"criteria": this.selectedDay, "result": true});
      setArray.push({"criteria": this.selectedRoom, "result": true});
      setArray.push({"criteria": this.selectedDepto, "result": true});
      setArray.push({"criteria": this.selectedSpeaker, "result": true});

      if (setArray[ 0 ].criteria !== "-Todos os dias") {
        if (activity.date === this.selectedDay) {
          setArray[ 0 ].result = true;
        } else {
          setArray[ 0 ].result = false;
        }
      }

      if (setArray[ 1 ].criteria !== "-Todas as salas") {
        if (activity.location_id === this.selectedRoom) {
          setArray[ 1 ].result = true;
        } else {
          setArray[ 1 ].result = false;
        }
      }

      if (setArray[ 2 ].criteria !== "-Todas as atividades") {
        if (activity.depto_id === this.selectedDepto) {
          setArray[ 2 ].result = true;
        } else {
          setArray[ 2 ].result = false;
        }
      }

      if (setArray[ 3 ].criteria !== "-Todos os palestrantes") {

        if (activity.agenda.length > 0) {

          for (const aga of activity.agenda) {

            if (aga.member_id == this.selectedSpeaker) {

              setArray[ 3 ].result = true;
              break;

            } else {
              setArray[ 3 ].result = false;
            }

          }


        } else {
          setArray[ 3 ].result = false;
        }

        if (activity.topics.length > 0) {
          for (const topic of activity.topics) {
            if (topic.agenda.length > 0) {

              for (const agt of topic.agenda) {
                if (agt.member_id == this.selectedSpeaker) {
                  setArray[ 3 ].result = true;
                }
              }

            } else {
              setArray[ 3 ].result = false;
              //break;
            }

            if (setArray[ 3 ].result == true) {
              break;
            }

          }

        } else {
          //setArray[ 3 ].result = false;
        }

      }


      for (const item of setArray) {

        if (item.result) {
          ctrl = true;
        } else {
          ctrl = false;
          break;
        }
      }

      if (ctrl) {
        this.addActivity(activity);
      }

    })

    if (this._activities.length > 0) {
      this.notFound = false;
      if (this.selectedSpeaker !== "-Todos os palestrantes") {
        this.isSpeaker = true;
        const member = this.staffMembers.find((e) => {
          return e.id == this.selectedSpeaker
        })
        this.member_name = member.name;
        this.member_text = member.text;
        this.member_image = member.image ? member.image : null;
        this.member_state = member.state;
        this.member_country = member.country;

        console.log("this.member_country: " + JSON.stringify(this.member_country));

        const flag = this.countries.find((e) => {
          return e.country == member.country;
        })
        this.member_flag = flag ? flag.image : null
        console.log("this.member_flag: " + JSON.stringify(this.member_flag));

        this.criteria = this.member_name + " (" + this.member_state + ", " + this.member_country + ")";


      } else {
        this.isSpeaker = false;
        this.member_name = "";
        this.member_text = "";
        this.member_image = "";
        this.member_flag = "";
        this.criteria = "";
      }
    } else {
      this.clearSpeaker();
      this.notFound = true;
    }

  }

  clearFilters () {
    this.selectedDay = "-Todos os dias";
    this.selectedRoom = "-Todas as salas";
    this.selectedDepto = "-Todas as atividades";
    this.selectedSpeaker = "-Todos os palestrantes";
    this.criteria = ""
    this.notFound = false;
    this._activities = this.activities;
    this.clearSpeaker();
    this.activities = this.allActivities;
  }

  clearSpeaker () {
    this.isSpeaker = false;
    this.member_name = "";
    this.member_state = "";
    this.member_text = "";
    this.member_image = "";
    this.member_flag = "";
    this.criteria = "";
  }

  addActivity (activity) {

    const exist = this._activities.find((e) => {
      return e.id === activity.id
    })
    if (!exist) {
      this._activities.push(activity)
    }
  }


  showGuest (entity) {

    this._dialog.open(EventGuestDialogComponent, {
      width: '700px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: entity
    });
  }


  publish () {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: this.master.name + "<br><br>Publicar este programa?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this.publishSchedule(this.master, this.allActivities, this.speakers)
      }
    })
  }

  async publishSchedule (master: any, allActivities: any[], speakers: any[]) {
    try {
      /*
      console.log("master: " + JSON.stringify(master))
      console.log("------------------------------------")
      console.log("allActivities: " + JSON.stringify(allActivities))
      console.log("------------------------------------")
      console.log("speakers: " + JSON.stringify(speakers))
      */
      // LIMPA AGENDA /////////////////////////////
      const clearSpeakerAgendaResult = await this._publishV2Service.clearSpeakersAgenda(master.context_id);
      console.log("clearSpeakerAgendaResult: " + clearSpeakerAgendaResult)
      if (!clearSpeakerAgendaResult) {
        throw new Error("Erro ao limpar a Agenda");
      }

      // GRAVA AGENDA /////////////////////////////
      const publishSpeakersAgendaResult = await this._publishV2Service.publishSpeakersAgenda(speakers);
      console.log("publishSpeakersAgendaResult: " + publishSpeakersAgendaResult)
      if (!publishSpeakersAgendaResult) {
        throw new Error('Erro ao gravar agenda');
      }

      // LIMPA ACTIVITIES /////////////////////////////
      const clearActivitiesResult = await this._publishV2Service.clearActivities(master.context_id);
      console.log("clearActivitiesResult: " + clearActivitiesResult)
      if (!clearActivitiesResult) {
        throw new Error('Erro ao limpar atividade');
      }

      // GRAVA ACTIVITIES /////////////////////////////
      const publishSpeakersResult = await this._publishV2Service.publishActivities(allActivities);
      console.log("publishSpeakersResult: " + publishSpeakersResult)
      if (!publishSpeakersResult) {
        throw new Error('Erro ao gravar atividade');
      }

      this._dialog.open(AlertComponent, {
        width: '450px',
        height: '270px',
        panelClass: 'custom-dialog-container',
        data: {title: "Alerta", message: "Dados publicados com sucesso."}
      });

    } catch (error) {
      console.log("erro update ativities. " + error);
      this._dialog.open(AlertComponent, {
        width: '450px',
        height: '270px',
        panelClass: 'custom-dialog-container',
        data: {title: "Alerta", message: "Erro<br><br>" + error.message}
      });
    }
  }



}
